// Runtime Sentry environment from the hostname. The portal never set
// `environment`, so staging (dev-portal) and localhost traffic reported as
// environment:production and polluted triage (e.g. PORTAL-CLIENT-6PP/6PK are
// dev-portal, 5ZK/6P7 are localhost). Unrecognized hostnames stay 'production'
// so existing environment:production searches/alerts keep matching real
// production events.
// CommonJS on purpose, same as sentryAxiosFingerprint.js (see
// sentryEnvironment.verify.js).

function detectEnvironment(hostname) {
  const h = String(
    hostname !== undefined
      ? hostname
      : (typeof window !== 'undefined' && window.location && window.location.hostname) || ''
  )
  if (h === 'localhost' || h.startsWith('127.')) return 'development'
  if (h === 'dev-portal.holisticindustries.net') return 'staging'
  return 'production'
}

module.exports = { detectEnvironment }
